module.exports = __webpack_public_path__ + "static/img/聊天界面-添加.78a9f6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/聊天界面-添加.png
// module id = 1362
// module chunks = 382